import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import { getCompany, listUserCompanies } from "../../graphql";

export const getCompanyApi = createApi({
  reducerPath: "getCompanyData",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    fetchGetCompany: builder.query({
        query: () => ({ body: getCompany }),
      keepUnusedDataFor: Infinity,
      refetchOnMountOrArgChange: true,
      providesTags: ["GetCompanyData"],
    }),
  }),
});

export const {
  useFetchGetCompanyQuery,
} = getCompanyApi;
